import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import EnvironmentBanner, { getEnvironment } from "./components/common/EnvironmentBanner";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";

const SHOW_REDUX_STORE = import.meta.env.VITE_SHOW_REDUX_STORE === "true";
const store = configureStore({
  reducer: rootReducer,
  devTools: SHOW_REDUX_STORE,
});

// Prefix the tab title so non-prod tabs are distinguishable in the tab strip.
const environment = getEnvironment();
if (environment) document.title = `[${environment.label}] ${document.title}`;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <EnvironmentBanner />
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
